import isFunction from 'lodash/isFunction';
import isFinite from 'lodash/isFinite';

// FIXME: these sorting methods don't fully reverse the sort order with direction.
// See the tests for more info. It might be better to call Array#reverse() instead.
const getSign = (direction) => {
  if (direction === 'desc') {
    return -1;
  }
  return 1;
};

const getProp = (row, prop) => {
  if (isFunction(prop)) {
    return row[prop(row)];
  }
  return row[prop];
};

export const stringSort = (prop, direction) => {
  const sign = getSign(direction);

  return (a, b) => {
    const valA = getProp(a, prop) || '';
    const valB = getProp(b, prop) || '';

    const val = valA.localeCompare(valB);

    if (sign < 0 && val !== 0) {
      return sign * val;
    }

    return val;
  };
};

export const numberSort = (prop, direction) => {
  const sign = getSign(direction);

  return (a, b) => {
    const valA = getProp(a, prop);
    const valB = getProp(b, prop);

    // When both values are not numbers we assume they are equal
    // When valA is not a number we return 1 to push it to the end
    // When valB is not a number we return -1 to push it to the end
    if (!(isFinite(valA) || isFinite(valB))) {
      return 0;
    } else if (!isFinite(valA)) {
      return 1;
    } else if (!isFinite(valB)) {
      return -1;
    }

    if (sign < 0) {
      return valB - valA;
    }

    return valA - valB;
  };
};

export const dateSort = (prop, direction) => {
  const sign = getSign(direction);

  return (a, b) => {
    const valA = Date.parse(getProp(a, prop));
    const valB = Date.parse(getProp(b, prop));

    if (isNaN(valA) && isNaN(valB)) {
      return 0;
    } else if (isNaN(valA)) {
      return -sign;
    } else if (isNaN(valB)) {
      return sign;
    }

    if (valA > valB) { return sign; }
    if (valB > valA) { return -sign; }

    return 0;
  };
};



// WEBPACK FOOTER //
// ./node_modules/@localytics/loc-components/lib/TableUtils/sort.js